import { SET_PROGRESS, SET_EXTRACTION_PROGRESS, CLEAR_EXTRACTION_PROGRESS } from "../actions/types";

const initialState = {
  fileType: '',
  // Avanzamento vero dell'estrazione: null quando nessun file e' in lettura.
  extraction: null,
};

const docUploadProgressReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PROGRESS:
      return {
        ...state,
        fileType: action.payload,
      };
    case SET_EXTRACTION_PROGRESS:
      return {
        ...state,
        extraction: action.payload,
      };
    case CLEAR_EXTRACTION_PROGRESS:
      return {
        ...state,
        extraction: null,
      };
    default:
      return state;
  }
};

export default docUploadProgressReducer;
